import styled from '@emotion/styled';
import { motion } from 'framer-motion';

import { Glyph } from '../../common/Glyph';
import { HomeyIcon } from '../../common/HomeyIcon';

import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { getButtonImage } from './getButtonImage';

export const variants = {
  initial: { backgroundColor: theme.color.black_o_50 },
  true: { backgroundColor: theme.color.white_o_100 },
  false: { backgroundColor: theme.color.black_o_50 },
  whileTap: { backgroundColor: theme.color.white_o_100 },
};

export const childVariants = {
  initial: { color: theme.color.white_o_100 },
  true: { color: theme.color.green },
  false: { color: theme.color.white_o_100 },
  whileTap: { color: theme.color.green },
};

export function Button({ capabilityId, deviceId, isSingle }) {
  const [value, setValue, capabilityObj] = useCapabilityValue({
    deviceId: deviceId,
    capabilityId: capabilityId,
  });

  if (capabilityObj == null) return null;

  const { url, useIconObj } = getButtonImage(capabilityObj.id, capabilityObj);

  function handleClick() {
    if (capabilityObj.getable) {
      const prevValue = value;
      const nextValue = !prevValue;
      setValue(nextValue).catch((error) => {});

      return;
    }

    setValue(true).catch((error) => {});
  }

  return (
    <sc.Container>
      <sc.ButtonBase
        initial="initial"
        animate={value ? 'true' : 'false'}
        whileTap="whileTap"
        transition={{
          duration: 0.2,
        }}
        variants={variants}
        isSingle={isSingle}
        onClick={handleClick}
      >
        {useIconObj ? (
          <motion.span
            style={{ display: 'flex' }}
            transition={{
              duration: 0.2,
            }}
            variants={childVariants}
          >
            <HomeyIcon
              iconObj={capabilityObj.iconObj}
              size={isSingle ? '48px' : '32px'}
              color="currentColor"
            />
          </motion.span>
        ) : (
          <motion.span
            style={{ display: 'flex' }}
            transition={{
              duration: 0.2,
            }}
            variants={childVariants}
          >
            <Glyph size={isSingle ? '48px' : '32px'} color="currentColor" source={url} />
          </motion.span>
        )}
      </sc.ButtonBase>

      <sc.Title>{capabilityObj.title}</sc.Title>
    </sc.Container>
  );
}

const sc = {
  Container: styled.div`
    display: flex;
    flex: 0 0 50%;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${su(2)};
  `,
  Title: styled.div`
    color: ${theme.color.text_invert_o_50};
    line-height: 18px;
    text-align: center;
    padding: 0 ${su(1)};
  `,
  ButtonBase: styled(motion.button)`
    display: flex;
    position: relative;
    height: 100px;
    width: 100px;
    align-items: center;
    justify-content: center;
    margin: ${su(1)};
    border: 0;
    border-radius: 50%;
    outline: none;
    background-color: ${theme.color.black_o_50};
    cursor: pointer;
  `,
};
